import { createRequestTypes } from '../../../utils/actionHelpers';

export default createRequestTypes('PRODUCT', [
  'READ_PRODUCTS_LIST',
  'CREATE_PRODUCT',
  'UPDATE_PRODUCT',
]);
